import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { PHONE } from '../config';
import '../mobile.css';

const ChatSupportButton = ({ phone = PHONE }) => {
  const message = 'Hello, I need help with LegalApp.';
  const waLink = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      className="m-chat-fab"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={26} color="#fff" />
    </a>
  );
};

export default ChatSupportButton;
